import { useState } from 'react';

export default function WordToFractionQuestion({ question, onAnswer, disabled }) {
  const { phrase } = question.data;
  const [numVal, setNumVal] = useState('');
  const [denVal, setDenVal] = useState('');

  function handleSubmit() {
    if (!numVal || !denVal || disabled) return;
    onAnswer({ num: numVal, den: denVal });
    setNumVal('');
    setDenVal('');
  }

  function handleKey(e) {
    if (e.key === 'Enter') handleSubmit();
  }

  return (
    <div className="question-card">
      <p className="question-prompt">{question.prompt}</p>
      <div className="latvian-phrase">{phrase}</div>
      <div className="fraction-fields">
        <span className="field-label">Skaitītājs (augšā)</span>
        <div className="fraction-input-group">
          <input
            type="number"
            min="1"
            value={numVal}
            onChange={e => setNumVal(e.target.value)}
            onKeyDown={handleKey}
            disabled={disabled}
            placeholder="?"
            autoFocus
          />
          <div className="fraction-input-divider" />
          <input
            type="number"
            min="1"
            value={denVal}
            onChange={e => setDenVal(e.target.value)}
            onKeyDown={handleKey}
            disabled={disabled}
            placeholder="?"
          />
        </div>
        <span className="field-label">Saucējs (apakšā)</span>
      </div>
      <button
        className="submit-btn"
        onClick={handleSubmit}
        disabled={!numVal || !denVal || disabled}
      >
        Pārbaudīt
      </button>
    </div>
  );
}
